import * as yup from 'yup';

export const simpleRegisterSchema = yup.object().shape({
 name: yup.string().required('Campo obrigatório'),
});

export const simpleRegisterSchemaUpdate = yup.object().shape({
 name: yup.string().required('Campo obrigatório'),
 questions: yup.array().of(
  yup.object().shape({
   id_question_template: yup.number().required(),
  })
 ),
});
